module.exports = __webpack_public_path__ + "static/FKRomanStandard-75e66463e724abff6a37e16bbbafb0fb.woff2";